import cx from 'classnames'
import Icon from 'modules/ui/Icons'
import MaterialIcon from 'modules/ui/MaterialIcon'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'redux-little-router'
import { omit } from 'ramda'

export default function Button({
  children,
  className,
  disabled,
  focus,
  hover,
  icon,
  iconLeft,
  label,
  link,
  preset,
  rounded,
  svgIcon,
  theme,
  customTheme,
  ...props
}) {
  const selectedTheme = customTheme || theme
  const classes = cx(
    selectedTheme.button,
    {
      [selectedTheme.disabled]: disabled,
      [selectedTheme.iconLeft]: iconLeft,
      [selectedTheme.link]: link,
      [selectedTheme.rounded]: rounded,
      [selectedTheme.hover]: hover, // for storybook
      [selectedTheme.focus]: focus, // for storybook
    },
    selectedTheme[preset],
    className
  )
  const Component = link ? Link : BaseButton

  return (
    <Component
      disabled={disabled}
      className={classes}
      aria-label={props.ariaLabel}
      {...omit(['ariaLabel'], props)}
    >
      {children || label}
      <Icon
        show={Boolean(svgIcon)}
        svg={svgIcon}
        theme={{
          container: selectedTheme.icon,
          stroke: selectedTheme.iconStroke,
          fill: selectedTheme.iconFill,
        }}
      />
      <MaterialIcon
        show={Boolean(icon)}
        className={selectedTheme.icon}
        icon={icon}
      />
    </Component>
  )
}

Button.defaultProps = {
  preset: 'primary',
  disabled: false,
  rounded: false,
  ariaLabel: '',
}

Button.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  focus: PropTypes.bool,
  hover: PropTypes.bool,
  icon: PropTypes.string,
  iconLeft: PropTypes.bool,
  label: PropTypes.node,
  link: PropTypes.bool,
  preset: PropTypes.oneOf([
    'primary',
    'secondary',
    'secondaryGray',
    'whiteOnGreen',
    'whiteOnBlue',
    'blueOutline',
    'text',
    'whiteBorder',
    'none',
  ]),
  rounded: PropTypes.bool,
  svgIcon: PropTypes.string,
  customTheme: PropTypes.object,
}

function BaseButton(props) {
  return <button type="button" {...props} />
}
